// extracted by mini-css-extract-plugin
export default {"zoomModal":"C3-z","image":"D3-z","button":"E3-z","isOverlayShown":"F3-z"};